// extracted by mini-css-extract-plugin
export default {"form":"MealItemForm_form__6yC-R","button":"MealItemForm_button__uh-xz","amount":"MealItemForm_amount__Xk4RR"};